export default __webpack_public_path__ + "static/16081-b9b698ac22748d05b19c183f7e136af4.jpg";